import { action } from "@ember/object"
import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import type { Course, Unit } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import styles from "./course-unit.module.css"

interface Signature {
  Args: {
    unitInfo: Unit
    course: Course
    lesson: CardStack
    goToPrevUnit: (unitId: string) => void
    goToNextUnit: (unitId: string) => void
    planbook: Planbook
    rotationCalendar: RotationCalendar
  }
}

export default class CourseUnitComponent extends Component<Signature> {
  readonly styles = styles

  get hasPrevUnit() {
    let units = this.args.course.attributes.calendar.units
    let currentIndex = units.findIndex((unit) => unit.id === this.args.unitInfo.id)
    return currentIndex > 0
  }

  get hasNextUnit() {
    let units = this.args.course.attributes.calendar.units
    let currentIndex = units.findIndex((unit) => unit.id === this.args.unitInfo.id)
    return currentIndex < units.length - 1
  }

  @action
  prevUnit() {
    let units = this.args.course.attributes.calendar.units
    let currentIndex = units.findIndex((unit) => unit.id === this.args.unitInfo.id)
    if (currentIndex === -1 || currentIndex === 0) {
      return
    }

    let prevUnitId = units[currentIndex - 1]?.id

    if (prevUnitId) {
      this.args.goToPrevUnit(prevUnitId)
    }
  }

  @action
  nextUnit() {
    let units = this.args.course.attributes.calendar.units
    let currentIndex = units.findIndex((unit) => unit.id === this.args.unitInfo.id)
    if (currentIndex === -1 || currentIndex === units.length - 1) {
      return
    }

    let nextUnitId = units[currentIndex + 1]?.id

    if (nextUnitId) {
      this.args.goToNextUnit(nextUnitId)
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::ClassWebsite::CourseUnit": typeof CourseUnitComponent
  }
}
